import { useEffect } from 'react';

// Adds <meta name="robots" content="noindex, nofollow"> to the document head
// while the calling component is mounted. Use on any page that should not be
// indexed by search engines (admin pages, the scorecard form, individual result pages).
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);
}
